<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="serviceTypesGridContainer"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [allowColumnReordering]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'service-types-grid-state', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            (onRowUpdating)="onRowUpdating($event)"
            (onRowDblClick)="onRowDblClick($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-editing
                [mode]="'row'"
                [allowUpdating]="canManage"
                [allowAdding]="canManage"
                [allowDeleting]="canManage"
                [useIcons]="true"
            >
            </dxo-editing>
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>
            
            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Service Types</div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton" 
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton" showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                    <dx-button class="ms-sm-2" text="New" icon="plus" type="default" stylingMode="contained" [visible]="canManage" (onClick)="addNew()"></dx-button>
                </dxi-item>
            </dxo-toolbar>
            <dxi-column [dataField]="gridFieldName('name')" caption="Type" dataType="string" alignment="left" [minWidth]="20">
                <dxi-validation-rule type="required" message="Type is required"></dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [max]="150" message="Type cannot exceed 150 characters"></dxi-validation-rule>
            </dxi-column>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="filterModelName('name')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Name', stylingMode: 'filled' }" [label]="{ text: 'Type' }"></dxi-item>
        </dx-form>
    </filter-panel>
</div>
